import { Injectable } from '@angular/core';
import { BackendService } from '../../services/new-http/backend.service';

@Injectable({
    providedIn: 'root',
})
export class AveragePriceApiService extends BackendService {
    public get(url: string) {
        return this.advisoryApi.get(url);
    }

    public put(url: string, body: any) {
        return this.advisoryApi.put(url, body)
    }

    public post(url: string, body: any) {
        return this.advisoryApi.post(url, body)
    }
}